import React from 'react';
// import TeacherInformationContainer from "../Container/TeacherInformationContainer";
import TeacherFormContainer from '../Container/TeacherFormContainer';
import PersonalForm2 from './PersonalForm2';
//redux
import { connect } from 'react-redux';
import { updatePersonalDetails } from '../../redux/homePage/homePage.actions';
// import { parseDate } from '../../Helper';
import { notify } from 'react-notify-toast';
import { dateToISO } from '../../Helper';

import { API } from '../../API';

const tabs = [
  {
    pathname: '/personalDetails',
    text: 'Personal Details',
    active: true,
  },
  {
    pathname: '/emergencyContact',
    text: 'Emergency',
  },
  {
    pathname: "/preferredWorkLocations",
    text: "Work Locations",
  },
];

// const loadDate = (date) => {
//   if (typeof date === 'string') {
//     const arr = date.split('-');
//     return new Date(arr[0], arr[1] - 1, arr[2]);
//   } else {
//     return date;
//   }
// };

// export const saveDate = (date) => {
//   if (date) {
//     let d = new Date(date - date.getTimezoneOffset() * 1000 * 60);
//     // console.log(d)
//     d = d.toISOString().slice(0, 10); // YYYY-MM-DD
//     // console.log(d);
//     return d;
//   }
// };

class PersonalDetails2 extends React.Component {
  constructor(props) {
    super(props);

    const address_line =
      this.props.user.address_line1 ||
      (this.props.user.street_name && this.props.user.street_number
        ? this.props.user.street_number + ', ' + this.props.user.street_name
        : ' ');

    this.state = {
      first_name: this.props.user.first_name,
      last_name: this.props.user.last_name,
      middle_name: this.props.user.middle_name,
      preferred_name: this.props.user.preferred_name,
      prefered_work_location: this.props.user.prefered_work_location,
      date_of_birth: this.props.user.date_of_birth && new Date(this.props.user.date_of_birth),
      contact_number: this.props.user.contact_number,
      state: this.props.user.state,
      suburb: this.props.user.suburb,
      email: this.props.user.email,
      postcode: this.props.user.postcode,
      contact_number_verified: this.props.user.contact_number_verified,
      address_line1: address_line,
      address_line2: this.props.user.address_line2,
      country: this.props.user.country,
      region: this.props.user.region,
      city: this.props.user.city,
     // whereby_link: this.props.user.whereby_link,
    };

    if (this.user === null) {
      window.location = '/login';
    }
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value });
    console.log(key + " insert " + value);
  };

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleNumberChange = (event) => {
    this.setState({value:event})
    this.setState({contact_number: event})
  }

  handleDateChange = (date) => {
    // saveDate(date)
    this.setState({ date_of_birth: date });
  };

  onLocationChange = (location) => {
    this.setState({country: location.country });
    this.setState({region: location.region });
    this.setState({city: location.city });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const fields = [
      'first_name',
      'last_name',
      'middle_name',
      'preferred_name',
      'contact_number',
      'date_of_birth',
      'address_line1',
      'address_line2',
      'suburb',
      'state',
      'postcode',
      'prefered_work_location',
      'country',
      'region',
      'city'
     // 'whereby_link',
    ];
    let errors = false;

    for (let field of fields) {
      if (field !== 'prefered_work_location') {
        const input = document.getElementById(field);
        console.log(input)
        if (!input.reportValidity()) {
          errors = true;
          break;
        }
      }
    }

    // fields.forEach((field) => {
    //   const input = document.getElementById(field)
    //   if (!input.reportValidity()) {
    //     errors = true
    //   }
    // })

    // if (!this.state.contact_number_verified) {
    //   notify.show("Please verify your phone number")
    //   errors = true
    // }

    if (errors) {
      notify.show('You are missing one or more field(s)!');
    } else if (this.state.contact_number_verified === false) {
      notify.show('Please verify the contact number');
      errors = true;
    }

    if (!errors) {
      // Email notification
      API.sendTeacherProfileProgressEmail({
        _id: this.props.user._id,
        to: this.props.user.email,
        first_name: this.props.user.first_name,
        etype: 'PID_CONF',
      }).then((result) => {
          console.log('result:', result);
        })
        .catch((err) => {
          console.log('err:', err);
        });
    }

    if (!errors) {
      this.props.updatePersonalDetails({
        ...this.state,
        date_of_birth: dateToISO(this.state.date_of_birth),
      });
    }
  };

  componentDidMount(){
    console.log(this.props);
  }

  render() {
    return (
      <div>
        <TeacherFormContainer
          header='Personal Information'
          tabs={tabs}
          handleSubmit={this.handleSubmit}
        >
          {
            // console.log(this.state.date_of_birth)
            // saveDate(this.state.date_of_birth)
          }
          <PersonalForm2
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleDateChange={this.handleDateChange}
            handleNumberChange={this.handleNumberChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails2);
